import { useCallback } from "react";

import { useAppSelector } from "app/redux-store-interactions";
import { useExplorerGlobals } from "contexts/explorerGlobals";
import { useSceneId } from "hooks/useSceneId";
import { selectProcoreContext } from "slices/explorer";
import type { OfflineDownloadStatusPayload } from "types/events";

import type { OfflineDownloadStatusUpdate } from "./hostEvents";

/**
 * Reports offline status changes to the host embedding the viewer, through the emitter the
 * Webviewer bridge forwards to `webviewer.eventEmitter`, each stamped with the open scene's ids, and
 * the open scene's state once it opens. Incremental caching is never reported.
 */
export function useEmitDownloadStatus() {
    const {
        state: { internalEventEmitter },
    } = useExplorerGlobals();
    const sceneId = useSceneId();
    const procoreContext = useAppSelector(selectProcoreContext);
    const sceneVersionId = procoreContext?.sceneVersionId;
    const sceneSliceId = procoreContext?.sceneSliceId;

    return useCallback(
        (source: OfflineDownloadStatusPayload["source"], update: OfflineDownloadStatusUpdate) => {
            void internalEventEmitter?.emit("offlineDownloadStatus", {
                ...update,
                sceneId,
                ...(sceneVersionId ? { sceneVersionId } : {}),
                ...(sceneSliceId ? { sceneSliceId } : {}),
                source,
            });
        },
        [internalEventEmitter, sceneId, sceneVersionId, sceneSliceId],
    );
}
